import "react-datepicker/dist/react-datepicker.css";
import "./index.css";

import DatePicker from "react-datepicker";
import { DatePickerHeader } from "./DatePickerHeader";
import { makeStyles } from "@mui/styles";
import { memo } from "react";

const useStyles = makeStyles({
  calendar: {
    display: "flex",
    justifyContent: "center",
    fontSize: "14px",
    border: "none",
    "& div": {
      background: "transparent",
    },
  },
});

export const DatePickerCalendar = memo(
  ({ filterDate, date, onChange, pastDates }) => {
    const styles = useStyles();

    return (
      <DatePicker
        selected={date}
        onChange={onChange}
        showMonthDropdown
        showYearDropdown
        inline
        filterDate={filterDate}
        calendarClassName={styles.calendar}
        renderCustomHeader={(props) => (
          <DatePickerHeader pastDates={pastDates} {...props} />
        )}
        fixedHeight
        onMonthChange={onChange}
        onYearChange={onChange}
      />
    );
  }
);
